module.exports = __webpack_public_path__ + "static/media/planning5@3x.40414433.png";